<div class="sj" [attr.aria-busy]="state() === 'joining'">
  <div class="sj__card">

    @if (state() === 'error') {
      <app-error-state
        titleKey="SESSION_JOIN.ERROR_TITLE"
        messageKey="SESSION_JOIN.ERROR_MESSAGE"
        [detail]="detail()"
        (retry)="join()" />
    } @else {
      <span class="sj__icon" [ngClass]="'sj__icon--' + state()" aria-hidden="true">
        <i class="fa-solid" [ngClass]="icon()"></i>
      </span>

      <h1 class="sj__title">{{ 'SESSION_JOIN.TITLE' | translate }}</h1>

      @switch (state()) {
        @case ('joining') {
          <p class="sj__lead" aria-live="polite">{{ 'SESSION_JOIN.JOINING' | translate }}</p>
        }
        @case ('redirecting') {
          <p class="sj__lead" aria-live="polite">{{ 'SESSION_JOIN.RECORDED' | translate }}</p>
          @if (countsFrom(); as time) {
            <p class="sj__note">{{ 'SESSION_JOIN.COUNTS_FROM' | translate: { time } }}</p>
          }
          @if (meetingUrl(); as url) {
            <!-- La présence est déjà enregistrée : ce lien direct est le secours
                 d'un navigateur qui ne suivrait pas la redirection. -->
            <a class="btn btn-primary mt-3" [href]="url" rel="noopener">
              <i class="fa-solid fa-video me-1" aria-hidden="true"></i>
              {{ 'SESSION_JOIN.OPEN_MANUALLY' | translate }}
            </a>
          }
        }
        @case ('refused') {
          <p class="sj__lead">{{ refusalKey() | translate }}</p>
        }
        @case ('not-found') {
          <p class="sj__lead">{{ 'SESSION_JOIN.NOT_FOUND' | translate }}</p>
        }
      }
    }

    @if (isTerminal()) {
      <div class="sj__actions">
        <a class="btn btn-outline-primary" [routerLink]="agendaLink">
          <i class="fa-solid fa-calendar-days me-1" aria-hidden="true"></i>
          {{ 'SESSION_JOIN.BACK_TO_AGENDA' | translate }}
        </a>
      </div>
    }

  </div>
</div>
